const DASHBOARD_VARIANTS = {
    TIK: 'tik',
    BASIC: 'basic',
    KO_TATOU: 'ko_tatou'
};

export const KO_TATOU_FEATURE_KEY = 'koTatouReporting';

export const DEFAULT_DASHBOARD_FORM_ID = 1;

// Keep dashboard support explicit so new form types can opt in without hard-coding
// behaviour throughout the dashboard shell.
const DASHBOARD_FORM_REGISTRY = {
    1: {
        dashboardVariant: DASHBOARD_VARIANTS.TIK,
        defaultSelected: true
    },
    4: {
        dashboardVariant: DASHBOARD_VARIANTS.BASIC
    },
    13: {
        dashboardVariant: DASHBOARD_VARIANTS.KO_TATOU,
        requiredFeature: KO_TATOU_FEATURE_KEY
    }
};

const normaliseFormId = (formId) => {
    const parsedFormId = Number.parseInt(formId, 10);
    return Number.isNaN(parsedFormId) ? null : parsedFormId;
};

export const buildDashboardForms = (forms, features) => (
    forms
        .map((form) => {
            const formId = normaliseFormId(form?.id);
            const config = DASHBOARD_FORM_REGISTRY[formId];

            if (!config) return null;
            if (config.requiredFeature && !features.includes(config.requiredFeature)) return null;

            return {
                ...form,
                id: formId,
                dashboardVariant: config.dashboardVariant,
                defaultSelected: Boolean(config.defaultSelected)
            };
        })
        .filter(Boolean)
        .sort((left, right) => {
            if (left.defaultSelected !== right.defaultSelected) {
                return Number(right.defaultSelected) - Number(left.defaultSelected);
            }

            return left.title.localeCompare(right.title);
        })
);

export const getDashboardFormConfig = (formId) => {
    const normalisedFormId = normaliseFormId(formId);
    return DASHBOARD_FORM_REGISTRY[normalisedFormId] || { dashboardVariant: DASHBOARD_VARIANTS.BASIC };
};

export { DASHBOARD_VARIANTS };
